import { render, staticRenderFns } from "./PhoneBookDialog.vue?vue&type=template&id=1f7281bc&scoped=true&"
import script from "./PhoneBookDialog.vue?vue&type=script&lang=js&"
export * from "./PhoneBookDialog.vue?vue&type=script&lang=js&"
import style0 from "./PhoneBookDialog.vue?vue&type=style&index=0&id=1f7281bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7281bc",
  null
  
)

export default component.exports